// src/features/contact/contactSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/api';

export const fetchContact = createAsyncThunk('contact/fetch', async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get('contact-page', { signal }); return r.data.data; } catch (e) { return rejectWithValue(e?.response?.data || e.message); }
});

const slice = createSlice({
  name: 'contact',
  initialState: { contactData: null, status: 'idle', error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchContact.pending, (s) => { s.status = 'loading'; s.error = null; })
     .addCase(fetchContact.fulfilled, (s, a) => { s.status = 'succeeded'; s.contactData = a.payload; })
     .addCase(fetchContact.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload || a.error.message; });
  }
});

export const contactState = (state) => state.contact;
export default slice.reducer;
